module.exports = __webpack_public_path__ + "static/img/S.05980fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qh/S.png
// module id = nV1+
// module chunks = 0